import { invitationsEndpoints } from "@/constants";
import { axiosClient } from "@/services/axios-client";
import type { AcceptInvitationRequestType, MessageResponseType } from "@/types";

export const acceptInvitationHandler = async (
    token: string,
    {
        companyName,
        name,
        password,
        passwordConfirmation,
        phone,
    }: AcceptInvitationRequestType,
): Promise<MessageResponseType> => {
    const payload = {
        company_name: companyName, // eslint-disable-line code-style/prop-naming-convention -- backend snake_case payload
        name: name,
        password: password,
        password_confirmation: passwordConfirmation, // eslint-disable-line code-style/prop-naming-convention -- backend snake_case payload
        phone: phone,
    };

    const response = await axiosClient.post<MessageResponseType>(
        invitationsEndpoints.accept(token),
        payload,
    );

    return { message: response.data.message };
};
